import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData,
  type DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteError,
  type DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteResponse,
  deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDelete,
} from '../../generated';

export type DeleteCollectionMutationVariables =
  DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData['path'];

export type DeleteCollectionMutation =
  DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteResponse;

export const useDeleteCollectionMutation = <
  TError = DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>({
    mutationKey: ['DeleteCollection'],
    mutationFn: async ({ workspace_id, collection_id }: DeleteCollectionMutationVariables) => {
      const { data } = await deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDelete({
        path: { workspace_id, collection_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeleteCollectionMutation.fetcher = (
  { workspace_id, collection_id }: DeleteCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDelete({
      path: { workspace_id, collection_id },
      throwOnError: true,
    });
    return data;
  };
};
